// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.structured_product_title_box {
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
}

.structured_product_layout {
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-bottom: 2rem;
}

.structured_product_details_box {
  display: flex;
  flex-direction: column;
  background-color: var(--bg-card);
  padding: 20px;
  border-radius: 15px;
  border: 1px solid var(--border);
  box-shadow: var(--shadow-sm);
}

.structured_product_informations {
  display: flex;
  flex-direction: row;
  justify-content: start;
  gap: 200px;
  align-items: center;
  background-color: var(--bg-card);
  padding: 20px;
  border-radius: 15px;
  border: 1px solid var(--border);
  box-shadow: var(--shadow-sm);
}

.structured_product_details_box_title {
  margin: 0 0 20px 0;
  font-size: 22px;
  font-weight: bold;
}

.structured_product_registerinfo {
  display: flex;
  flex-direction: column;
}

.structured_product_box{
  display: flex;
  flex-direction: column;
  gap: 7px;
}

.structured_product_p {
  margin: 5px 0;
}

.structured_product_item_title {
  margin: 0;
  font-size: 13px;
  display: block;
  color: var(--text-muted);
}

.structured_product_item_desc{
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: var(--text-secondary);
}

.structured_product_chiffres {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
}

.structured_product_chiffres_user {
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: var(--bg-card);
  padding: 20px;
  border-radius: 15px;
  border: 1px solid var(--border);
  box-shadow: var(--shadow-sm);
}

.structured_product_doc_title {
  margin: 0 0 20px 0;
  font-size: 22px;
  font-weight: bold;
}

.structured_product_box{
  display: flex;
  flex-direction: column;
  gap: 7px;
}

.structured_product_actions_box {
  display: flex;
  flex-direction: row;
  justify-content: end;
  margin-bottom: 2rem;
  gap: 15px;
}

.structured_product_gen_report_button {
  background-color: var(--primary);
  color: white;
  border-radius: 5px;
  border: none;
  padding: 10px 20px;
  font-weight: bold;
}

.structured_product_copy_button {
  background-color: var(--bg-card);
  color: var(--primary);
  border-radius: 5px;
  border: 1px solid var(--primary);
  padding: 10px 20px;
  font-weight: bold;
  cursor: pointer;
}

.structured_product_copy_button:hover {
  background-color: var(--primary-light);
}

.structured_product_refund_button {
  background-color: #b81313;
  color: white;
  border-radius: 5px;
  border: none;
  padding: 10px 20px;
  font-weight: bold;
}
.structured_product_back_link {
  display: inline-block;
  margin-bottom: 1rem;
  color: var(--text-secondary);
  text-decoration: none;
  font-weight: 600;
}

.structured_product_back_link:hover {
  color: var(--primary);
}

.structured_product_link_button {
  display: inline-flex;
  align-items: center;
  text-decoration: none;
}
`, "",{"version":3,"sources":["webpack://./src/pages/finances/subpages/StructuredProducts/StructuredProductById/structuredProductById.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,UAAU;EACV,mBAAmB;EACnB,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gCAAgC;EAChC,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;EAChC,qBAAqB;EACrB,kBAAkB;EAClB,gCAAgC;EAChC,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,4BAA4B;EAC5B,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,qBAAqB;AACvB","sourcesContent":[".structured_product_title_box {\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 2rem;\n}\n\n.structured_product_layout {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  margin-bottom: 2rem;\n}\n\n.structured_product_details_box {\n  display: flex;\n  flex-direction: column;\n  background-color: var(--bg-card);\n  padding: 20px;\n  border-radius: 15px;\n  border: 1px solid var(--border);\n  box-shadow: var(--shadow-sm);\n}\n\n.structured_product_informations {\n  display: flex;\n  flex-direction: row;\n  justify-content: start;\n  gap: 200px;\n  align-items: center;\n  background-color: var(--bg-card);\n  padding: 20px;\n  border-radius: 15px;\n  border: 1px solid var(--border);\n  box-shadow: var(--shadow-sm);\n}\n\n.structured_product_details_box_title {\n  margin: 0 0 20px 0;\n  font-size: 22px;\n  font-weight: bold;\n}\n\n.structured_product_registerinfo {\n  display: flex;\n  flex-direction: column;\n}\n\n.structured_product_box{\n  display: flex;\n  flex-direction: column;\n  gap: 7px;\n}\n\n.structured_product_p {\n  margin: 5px 0;\n}\n\n.structured_product_item_title {\n  margin: 0;\n  font-size: 13px;\n  display: block;\n  color: var(--text-muted);\n}\n\n.structured_product_item_desc{\n  margin: 0;\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--text-secondary);\n}\n\n.structured_product_chiffres {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  gap: 20px;\n}\n\n.structured_product_chiffres_user {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  background-color: var(--bg-card);\n  padding: 20px;\n  border-radius: 15px;\n  border: 1px solid var(--border);\n  box-shadow: var(--shadow-sm);\n}\n\n.structured_product_doc_title {\n  margin: 0 0 20px 0;\n  font-size: 22px;\n  font-weight: bold;\n}\n\n.structured_product_box{\n  display: flex;\n  flex-direction: column;\n  gap: 7px;\n}\n\n.structured_product_actions_box {\n  display: flex;\n  flex-direction: row;\n  justify-content: end;\n  margin-bottom: 2rem;\n  gap: 15px;\n}\n\n.structured_product_gen_report_button {\n  background-color: var(--primary);\n  color: white;\n  border-radius: 5px;\n  border: none;\n  padding: 10px 20px;\n  font-weight: bold;\n}\n\n.structured_product_copy_button {\n  background-color: var(--bg-card);\n  color: var(--primary);\n  border-radius: 5px;\n  border: 1px solid var(--primary);\n  padding: 10px 20px;\n  font-weight: bold;\n  cursor: pointer;\n}\n\n.structured_product_copy_button:hover {\n  background-color: var(--primary-light);\n}\n\n.structured_product_refund_button {\n  background-color: #b81313;\n  color: white;\n  border-radius: 5px;\n  border: none;\n  padding: 10px 20px;\n  font-weight: bold;\n}\n.structured_product_back_link {\n  display: inline-block;\n  margin-bottom: 1rem;\n  color: var(--text-secondary);\n  text-decoration: none;\n  font-weight: 600;\n}\n\n.structured_product_back_link:hover {\n  color: var(--primary);\n}\n\n.structured_product_link_button {\n  display: inline-flex;\n  align-items: center;\n  text-decoration: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
